// removed by extract-text-webpack-plugin
module.exports = {"Blackberry":"#333D47","orderStatus":"Gdbcfaa G8d5dc0 Gd71c60 G42bbcd G42bbcd undefined G813e5d"};